import { render, staticRenderFns } from "./KHyueShouRu.vue?vue&type=template&id=1a605832&scoped=true&"
import script from "./KHyueShouRu.vue?vue&type=script&lang=js&"
export * from "./KHyueShouRu.vue?vue&type=script&lang=js&"
import style0 from "./KHyueShouRu.vue?vue&type=style&index=0&id=1a605832&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a605832",
  null
  
)

export default component.exports